import React from 'react'
import {useStateContext} from '../context/StateContext';
import { CgProfile } from 'react-icons/cg';
import { urlFor } from '../lib/client';
import {VisDiv, DateLog} from '../components';
import { isGodMode, isAdmin } from '../lib/userPermissions';

/**
 * UserIcon component
 * 
 * @param {object} otherUser - other user object to display
 * @param {boolean} bypassCurrentUser - bypass current user and display other user
 * @param {function} onClick - click event handler
 * @param {string} date - date to display
 * @param {string} dateText - text to display as date
 * @param {string} sPicture - url of the user picture
 * @param {object} style - style object to apply to the container
 * @param {number} size - size of the user icon
 * @param {string} name - name of the user
 * @param {string} nameInitials - name initials of the user
 * @param {boolean} dateInline - whether to display date inline or not
 */
const UserIcon = ({otherUser, bypassCurrentUser, onClick, date="", dateText="", sPicture, style, size=30, name, nameInitials, dateInline}) => {
   
  const {sUser} = useStateContext()

    const showTime = () => {
        if(isAdmin(sUser) || isGodMode(sUser) ) return true
        return false
      }
    
    const iconSize  = {width:`${size}px`, height:`${size}px`}
    const enabledStyle = {cursor: "pointer",...style}
    const disabledStyle = {...style }
    
    const USER = otherUser ? otherUser : 
      bypassCurrentUser ? undefined : sUser 

    const userName =  (USER?.firstName ? USER?.firstName : "") + " " + (USER?.lastName ? USER?.lastName : "")
    
    const userPicture = () => {
      try {
        if(sPicture && Object.keys(sPicture).length > 0){
          return urlFor(sPicture)
        }
        if(USER?.image && Object.keys(USER.image).length > 0){
          return urlFor(USER.image)
        }
/*       if (user?.picture){
        return user?.picture
      } */
        return undefined    
      } catch (error) {
        console.error('Error resolving user picture:', error)
        return undefined
      }
    }

    // Store the picture URL to avoid calling userPicture() multiple times
    const pictureUrl = userPicture()

  return (
    <>
    <div className='menu-container-profile' onClick={onClick} style={onClick ? enabledStyle : disabledStyle}>
        {pictureUrl ?  <img style={{...iconSize}} className='profile-icon' src={pictureUrl} alt={userName || 'User avatar'}></img> :
        <CgProfile style={{...iconSize}} className='profile-icon' />} 
        <div>
          <VisDiv rules={[date]} style={{marginLeft:"3px", fontSize:"12px", fontWeight:"bold"}}><p>{dateText}</p></VisDiv>
          <VisDiv style={{marginLeft:"3px", fontSize:"12px"}} rules={[name, USER]}>{(userName).toUpperCase()}</VisDiv>
          <VisDiv style={{marginLeft:"3px", fontSize:"12px"}} rules={[nameInitials, USER]}>{(userName)?.toUpperCase()}</VisDiv> 
          <VisDiv rules={[date]}> <DateLog date={date} justDate={false} dateAndTime={showTime()}/></VisDiv>
        </div>

    </div>

    </>
  )
}

export default UserIcon

//<img className='profile-icon' src={userPicture()}></img>
